import { render, staticRenderFns } from "./LogicEditor.vue?vue&type=template&id=4c4a7710"
import script from "./LogicEditor.vue?vue&type=script&lang=js"
export * from "./LogicEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports